// services
import PowerBIService from '@/services/powerBIService'

export const ModuleName = 'powerBi'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getEmbededReportConfig ({ commit, state }, req) {
      var response = await PowerBIService.GetReport(req)
      return response
    }
  },
  getters: {}
}
